import { firestore } from '@src/api/Firebase/Firebase';
import { collection } from 'firebase/firestore';
import { InputCategory } from '@api/InputCategories/InputCategory';

export interface Input {
    id?: string;
    name: string;
    inputCategoryId: string;
    inputCategoryData?: InputCategory;
    presentation: {
        value: number;
        unit: string;
    };
    unit: {
        value: number;
        unit: string;
    };
    purchaseCost: number;
    costOfSale: number;
    // Derivados persistidos al guardar (InputServ.saveInput los recalcula SIEMPRE — no capturar a mano)
    unitCost?: number; // purchaseCost / unit.value → $ por unidad base (costo corporativo)
    unitCostSale?: number; // costOfSale / unit.value → $ por unidad base (costo al que recibe la sucursal)
    // % de desperdicio esperado — solo informativa para costeo teórico, NO afecta descuentos de stock
    merma?: number;
    sufficientThreshold: number;
    lowThreshold: number;
    criticalThreshold: number;
    distributionCentersAvailable?: string[];
}

// unit.value = cuántas unidades base rinde la presentación (la "unidad mínima" en la que consumen las recetas)
export const getUnitCost = (input: Pick<Input, 'purchaseCost' | 'unit'>): number => {
    if (!input.unit?.value || input.unit.value <= 0) {
        return 0;
    }
    return input.purchaseCost / input.unit.value;
};

export const getUnitCostSale = (input: Pick<Input, 'costOfSale' | 'unit'>): number => {
    if (!input.unit?.value || input.unit.value <= 0) {
        return 0;
    }
    return input.costOfSale / input.unit.value;
};

// Los costos unitarios pueden ser fracciones de centavo ($0.09/ml, $0.004/gr)
export const formatUnitCost = (value: number): string => {
    if (!Number.isFinite(value) || value <= 0) {
        return '$0';
    }
    return value < 0.1 ? `$${value.toFixed(4)}` : `$${value.toFixed(2)}`;
};

export const getStockStatus = (stock: number, input: Input) => {
    let label = 'Crítico';
    if (stock >= input.sufficientThreshold) {
        label = 'Suficiente';
    } else if (stock >= input.lowThreshold) {
        label = 'Stock bajo';
    }
    return label;
};

export const getStockStatusColor = (stock: number, input: Input) => {
    let color = 'error';
    if (stock >= input.sufficientThreshold) {
        color = 'success';
    } else if (stock >= input.lowThreshold) {
        color = 'warning';
    }
    return color;
};

export const INPUTS_COLLECTION = 'inputs';

export const inputsRef = collection(firestore, INPUTS_COLLECTION);
